import React from 'react';

const Lock = ({ width = '1.2rem', height = '1.2rem', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 21.827"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      transform="translate(-373.5 -1453.96)"
      d="M388.895,1463.112V1460.1a6.4,6.4,0,0,0-12.789,0v3.013a4.524,4.524,0,0,0-2.605,4.036v4.093a4.648,4.648,0,0,0,4.737,4.547h8.526a4.648,4.648,0,0,0,4.737-4.547v-4.093A4.524,4.524,0,0,0,388.895,1463.112Zm-4.5,5.807a1.9,1.9,0,1,1-1.895-1.819A1.858,1.858,0,0,1,384.395,1468.919Zm2.132-8.82a4.03,4.03,0,0,0-8.053,0v2.046a.462.462,0,0,0,.474.455h7.105a.462.462,0,0,0,.474-.455Z"
    />
  </svg>
);

export default Lock;
